package com.nonopn.skywatcher.common.app.portfolio.main

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.drawer.DrawerSizeShape
import com.nonopn.skywatcher.common.app.home.AppModel
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.home.LocalMenuState
import com.nonopn.skywatcher.common.app.navigation.PossibleRoutes
import com.nonopn.skywatcher.common.app.navigation.RouteNoThunderDetectionSelected
import com.nonopn.skywatcher.common.app.navigation.scaffold.FloatingActionButtonWrapper
import com.nonopn.skywatcher.common.app.navigation.scaffold.TopBarWrapper
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.alert_disconnect_text
import com.nonopn.skywatcher.common.app.res.alert_disconnect_title
import com.nonopn.skywatcher.design.local.LocalConfirmPopup
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.rememberSizeAwareScaffoldState
import eu.codlab.navigation.LocalNavigator
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigatorLocalProvider
import eu.codlab.navigation.ScaffoldContentWrapper
import eu.codlab.safearea.views.SafeArea
import eu.codlab.safearea.views.SafeAreaBehavior
import eu.codlab.viewmodel.rememberViewModel

@Composable
@Suppress("LongMethod", "ComplexMethod")
fun NoThunderDetectionSelectedContent(model: AppModel) {
    val noThunderDetectionSelectedModel = rememberViewModel {
        model.createNoThunderDetectionSelectedModel()
    }
    val scaffoldState = rememberSizeAwareScaffoldState()

    val popup = LocalConfirmPopup.current
    val disconnectTitle = Res.string.alert_disconnect_title.localized()
    val disconnectText = Res.string.alert_disconnect_text.localized()

    val scope = rememberCoroutineScope()

    LaunchedEffect(scaffoldState) {
        scaffoldState.drawerState.close()
    }

    NavigatorLocalProvider(noThunderDetectionSelectedModel) {
        noThunderDetectionSelectedModel.navigator = LocalNavigator.current

        LaunchedEffect(model, scaffoldState) {
            noThunderDetectionSelectedModel.mainCompositionScope = scope
            noThunderDetectionSelectedModel.scaffoldState = scaffoldState
        }

        val onMenuItemSelected: (String, NavigateTo) -> Unit = { newTitle, path ->
            noThunderDetectionSelectedModel.show(path)
        }

        val drawerContent: @Composable (
            Modifier,
            onMenuItemSelected: (title: String, navigateTo: NavigateTo) -> Unit,
            tiny: Boolean
        ) -> Unit = { modifier, onMenuItemSelected, tiny ->
            val noThunderDetectionSelectedModelState by noThunderDetectionSelectedModel.states.collectAsState()

            DrawerContentNoSelection(
                modifier = modifier,
                currentRoute = noThunderDetectionSelectedModelState.currentRoute,
                tiny = tiny,
                onDisconnect = {
                    popup.show(
                        disconnectTitle,
                        disconnectText,
                    ) {
                        model.logout()
                    }
                },
                onMenuItemSelected = onMenuItemSelected
            )
        }

        CompositionLocalProvider(
            LocalMenuState provides scaffoldState,
            LocalAppBarProvider provides noThunderDetectionSelectedModel,
        ) {
            SafeArea(
                SafeAreaBehavior(
                    extendToTop = true,
                    extendToBottom = true,
                    extendToStart = true,
                    extendToEnd = true
                )
            ) {
                Column {
                    Scaffold(
                        scaffoldState = scaffoldState,
                        topBar = { TopBarWrapper(disableMenuInBigScreen = true) },
                        floatingActionButton = { FloatingActionButtonWrapper() },
                        drawerContent = {
                            drawerContent(
                                Modifier.fillMaxSize(),
                                onMenuItemSelected,
                                false
                            )
                        },
                        drawerShape = DrawerSizeShape(),
                        content = {
                            ScaffoldContentWrapper(
                                noThunderDetectionSelectedModel,
                                possibleRoutes = PossibleRoutes.entriesNoDetectionSelected,
                                defaultRoute = RouteNoThunderDetectionSelected,
                                // drawerContent = drawerContent,
                                onMenuItemSelected = onMenuItemSelected
                            )
                        }
                    )
                }
            }
        }
    }
}
